<script lang="ts">
  import { cn } from '$lib/utils';
  import type { AssetStoryblok } from '$types/bloks';
  import CmsImage from './cms-image.svelte';

  export let image: AssetStoryblok | undefined = undefined;
  export let title: string | undefined = undefined;
  let className: string | undefined = undefined;
  export { className as class };
  export let scale = 1;
</script>

<section class={cn('px-2 lg:px-8', className)} style:--scale={scale}>
  <div class="container relative mx-auto flex w-full justify-center rounded-md overflow-hidden">
    {#if image?.filename}
      <CmsImage
        {image}
        class="aspect-square h-[360px] w-full overflow-hidden rounded-md scale-[var(--scale)] object-cover object-center lg:aspect-auto lg:h-[400px]"
        options={{ size: [1920, 0] }}
      />
    {/if}
    <div class="absolute inset-0 bg-primary/8"></div>
    <h1 class="absolute top-1/2 -translate-y-1/2 text-7xl font-semibold text-highlight">{title}</h1>
  </div>
</section>
